import {
  ShieldCheck, Scale, Home as HomeIcon, Gavel, Building2, Heart, Lock, FileCheck2, MessageSquare, Video, PhoneCall,
} from "lucide-react";

export const categories = [
  { icon: Heart, title: "Family", sub: "Divorce, custody", spec: "Family Law", cta: "Talk to Family Lawyer", color: "#F472B6" },
  { icon: HomeIcon, title: "Property", sub: "Rent, disputes", spec: "Property Law", cta: "Talk to Property Lawyer", color: "#60A5FA" },
  { icon: Gavel, title: "Criminal", sub: "FIR, bail", spec: "Criminal Law", cta: "Talk to Criminal Lawyer", color: "#F59E0B" },
  { icon: Building2, title: "Corporate", sub: "MSME, GST", spec: "Corporate Law", cta: "Talk to Corporate Lawyer", color: "#10B981" },
];

export const trustItems = [
  { icon: ShieldCheck, label: "Verified Lawyers Only" },
  { icon: Lock, label: "Secure Payments" },
  { icon: FileCheck2, label: "100% Confidential" },
  { icon: Scale, label: "Bar Council Registered" },
];

export const pricingTiers = [
  {
    icon: MessageSquare, title: "Chat", range: "₹199 – ₹299", sub: "15-min text consultation",
    bullets: ["Quick answers", "Fast turnaround", "Most affordable"],
    accent: "#0A2540",
  },
  {
    icon: PhoneCall, title: "Audio Call", range: "₹299 – ₹999", sub: "20-min voice call",
    bullets: ["Talk in Hindi or English", "Real-time clarifications", "Great for complex queries"],
    accent: "#D4AF37",
    popular: true,
  },
  {
    icon: Video, title: "Video Call", range: "₹499 – ₹1500", sub: "30-min face-to-face",
    bullets: ["Most personal", "Review documents on call", "Senior lawyer access"],
    accent: "#10B981",
  },
];

export const stats = [
  { v: "2,400+", l: "legal questions answered" },
  { v: "150+", l: "verified lawyers" },
  { v: "50+", l: "cities covered" },
  { v: "4.8/5", l: "average rating" },
];
